import { useQuery } from '@tanstack/vue-query'
import { computed, reactive } from 'vue'

import { User } from '@/types/curUser'
import getUserLabel from '@/utils/getUserLabel'

import { ReApi, ReApiVersion, ReEndpoint } from './query'
import { reactiveAny } from './utils/reactive'

// TODO: merge with useUser (after refactoring backend endpoint)
export default function useUserList(params = {}, options = { full: false }) {
  const queryKey = computed(() => [
    ReApi.AUTH,
    ReApiVersion.CURRENT,
    ReEndpoint.USER_LIST,
    options.full ? 'full' : 'basic',
    params,
  ])

  const query = useQuery<User[]>({
    queryKey: queryKey,
    placeholderData: [],
    select: (data) => {
      // Provide displayName for each user
      const withDisplayName = data.map((user) => ({
        ...user,
        displayName: getUserLabel(user),
      }))
      // Sort users by displayName
      return withDisplayName.sort((a, b) => {
        if (a.displayName < b.displayName) return -1
        if (a.displayName > b.displayName) return 1
        return 0
      })
    },
    staleTime: 60000, // 1 minute
  })

  const isBusy = reactiveAny(query.isLoading, query.isFetching)

  return reactive({
    isBusy,
    queryKey,
    ...query,
  })
}

// TODO: add support for valuer list
// load_valuers() {
//     let url = utils.urlJoin(this.$config.VALUATION_API_URL, 'users')
//     let params = { roles: 'valuer', modules: 'dvm' }
//     axios.get(url, { params }).then((result) => {
//         this.valuers.dvm = result.data
//         this.valuers.dvm.sort((a, b) => {
//             if (a.email < b.email) return -1
//             if (a.email > b.email) return 1
//             return 0
//         })
//     })
//     params = { roles: 'valuer', modules: 'ovm' }
//     axios.get(url, { params }).then((result) => {
//         this.valuers.ovm = result.data
//         this.valuers.ovm.sort((a, b) => {
//             if (a.email < b.email) return -1
//             if (a.email > b.email) return 1
//             return 0
//         })
//     })
// },
